import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handle(req, next));
  }

  private async handle(req: HttpRequest<any>, next: HttpHandler) {
    try {
      // Exclude token refresh requests from interception
      if (
        req.url.includes('/refresh-token') ||
        req.url.includes('signin/anonymous') ||
        req.url.includes('customer-access-file/list') ||
        req.url.includes('customer-access-file/download') ||
        req.url.includes('./assets/')
      ) {
        return lastValueFrom(next.handle(req)); // Skip interception
      }

      const { data, error } = await this.authService.getSession();
      if (error) {
        throw error;
      }

      if (data.session?.access_token) {
        const type = data.session.token_type || 'Bearer';
        const header = req.clone({
          setHeaders: {
            authorization: [type, data.session.access_token].join(' '),
          },
        });
        return lastValueFrom(next.handle(header));
      } else {
        return lastValueFrom(next.handle(req));
      }

    } catch (e) {
      throw e;
    }
  }
}
